import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

let searchUrl = window.location.search || null
if(searchUrl) {
    window.sessionStorage.setItem('searchUrl', ('&'+searchUrl.split('?')[1]) );
}

ReactDOM.render(
    <BrowserRouter>
        <Switch>
            <Route path="/">
                <App></App>
            </Route>
        </Switch>
    </BrowserRouter>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
